import { _ } from "vue-underscore";

const tribuneF = {
  tribunePrefix: "F",
  seats: [..._.range(92, 0, -1)],
  rows: [
    {
      name: 5,
      items: ["empty", ..._.range(92, 72, -1)]
    },
    {
      name: "stairs",
      items: ["stairs", ...Array(18).fill("empty"), "stairs", "stairs"]
    },
    { name: 4, items: ["empty", ..._.range(72, 54, -1), "empty", "empty"] },
    {
      name: "stairs",
      items: ["stairs", ...Array(18).fill("empty"), "stairs", "stairs"]
    },
    { name: 3, items: ["empty", ..._.range(54, 36, -1), "empty", "empty"] },
    {
      name: "stairs",
      items: ["stairs", ...Array(18).fill("empty"), "stairs", "stairs"]
    },
    { name: 2, items: ["empty", ..._.range(36, 18, -1), "empty", "empty"] },
    {
      name: "stairs",
      items: ["stairs", ...Array(18).fill("empty"), "stairs", "stairs"]
    },
    { name: 1, items: ["empty", ..._.range(18, 0, -1), "empty", "empty"] },
  ]
};

export default tribuneF;
